import React, { Fragment, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { Trans } from '@lingui/macro';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import Message, { THEME } from '@mos-cat/message';
import { Button, Heading } from '@mos-cat/typography';
import { Step } from '@mos-front-components/public/es/components/Steps';
import { StepProps } from '@mos-front-components/public/es/components/Steps/private/Step/Step';

import ChildModal from '../ChildModal/ChildModal';
import ChildCardList from '../ChildCardList/ChildCardList';
import { childrenModalOpen } from '../../../models/modals';
import ChildrenModal from '../ChildrenModal/ChildrenModal';
import { isChildrenStepDisabled } from '../../../models/children';
import {
  childrenStepCompleted,
  getNotHiddenChildren,
} from '../../../selectors/children';
import './ChildrenData.pcss';
import {
  ADD_CHILD,
  formError,
  sendStats,
  useChildrenSendStats,
  useStepCompleteSendStats,
} from '../../../helpers/stats';
import { useChildrenError } from '../../../helpers/useChildrenError';
import { isStatsSending } from '../../../selectors/submit';
import {
  sendCMABusinessError,
  sendCMAFormStepChange,
} from '../../../helpers/CMAstats';

interface Props {
  step?: StepProps;
  onAddChild(): void;
  disabled: boolean;
  isStatsSending: boolean;
  stepCompleted: boolean;
  childrenCount: number;
  error?: 'quantity' | 'benefits';
}

function ChildrenData({
  step,
  onAddChild,
  disabled,
  stepCompleted,
  error,
  childrenCount,
  isStatsSending,
}: Props): JSX.Element {
  const { text: errorText } = useChildrenError(error);

  useEffect(() => {
    if (error === 'quantity') {
      sendStats(formError('Добавлено менее трех детей'));
      sendCMABusinessError('step');
    }
  }, [error]);

  useEffect(() => {
    sendCMAFormStepChange();
  }, []);

  useChildrenSendStats(isStatsSending, childrenCount, { stepNumber: step });

  useStepCompleteSendStats(isStatsSending, stepCompleted, {
    stepNumber: step,
    stepTitle: 'Сведения о детях',
    childrenCount,
  });

  const handleAddChild = () => {
    sendStats(ADD_CHILD);
    onAddChild();
  };
  const content = disabled ? null : (
    <Fragment>
      <ChildCardList />
      <div className="StepContentBlock ChildrenTextBlock">
        <p className="FormSteps__Text">
          <Trans>
            Вам необходимо заполнить данный блок, указав сведения о всех ваших
            детях (в том числе о пасынках и падчерицах, но не менее, чем о
            трех).
          </Trans>
        </p>
      </div>
      {error && (
        <div className="StepContentBlock ChildrenTextBlock">
          <Fragment>
            <Message theme={THEME.DANGER} className="ChildrenError">
              {errorText}
            </Message>
          </Fragment>
        </div>
      )}
      <Button primary onClick={handleAddChild}>
        <Trans>Добавить ребёнка</Trans>
      </Button>
      <ChildModal />
      <ChildrenModal />
    </Fragment>
  );

  return (
    <Step
      className="FormPage__Step"
      step={step}
      completed={stepCompleted}
      disabled={disabled}
      title={
        <Heading level={2} className="FormSteps__StepTitle">
          <Trans>Сведения о детях</Trans>
        </Heading>
      }
    >
      {content}
    </Step>
  );
}

const mapStateToProps = createStructuredSelector<any, any>({
  stepCompleted: childrenStepCompleted,
  error: (state) => state.steps.children.error,
  disabled: isChildrenStepDisabled,
  childrenCount: (state) => getNotHiddenChildren(state).length,
  isStatsSending,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onAddChild() {
    dispatch({
      type: 'child/reset',
    });
    dispatch(childrenModalOpen(true));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChildrenData);
